export const CITIES = [
	'Bakonycsernye',
	'Balatonakarattya',
	'Bóly',
	'Borszörcsök',
	'Budapest',
	'Doba',
	'Hortobágy',
	'Komló',
	'Kozármisleny',
	'Mosdós',
	'Nemeskisfalud',
	'Örvényes',
	'Pincehely',
	'Tárkány',
	'Aba',
	'Abádszalók',
	'Abaliget',
	'Abasár',
	'Abaújalpár',
	'Abaújkér',
	'Abaújlak',
	'Abaújszántó',
	'Abaújszolnok',
	'Abaújvár',
	'Abda',
	'Abod',
	'Abony',
	'Ábrahámhegy',
	'Ács',
	'Acsa',
	'Acsád',
	'Acsalag',
	'Ácsteszér',
	'Adács',
	'Ádánd',
	'Adásztevel',
	'Adony',
	'Adorjánháza',
	'Adorjás',
	'Ág',
	'Ágasegyháza',
	'Ágfalva',
	'Aggtelek',
	'Agyagosszergény',
	'Ajak',
	'Ajka',
	'Aka',
	'Akasztó',
	'Alacska',
	'Alap',
	'Alattyán',
	'Albertirsa',
	'Alcsútdoboz',
	'Aldebrő',
	'Algyő',
	'Alibánfa',
	'Almamellék',
	'Almásfüzitő',
	'Almásháza',
	'Almáskamarás',
	'Almáskeresztúr',
	'Álmosd',
	'Alsóberecki',
	'Alsóbogát',
	'Alsódobsza',
	'Alsógagy',
	'Alsómocsolád',
	'Alsónána',
	'Alsónémedi',
	'Alsónemesapáti',
	'Alsónyék',
	'Alsóörs',
	'Alsópáhok',
	'Alsópetény',
	'Alsórajk',
	'Alsóregmec',
	'Alsószenterzsébet',
	'Alsószentiván',
	'Alsószentmárton',
	'Alsószölnök',
	'Alsószuha',
	'Alsótelekes',
	'Alsótold',
	'Alsóújlak',
	'Alsóvadász',
	'Alsózsolca',
	'Ambrózfalva',
	'Anarcs',
	'Andocs',
	'Andornaktálya',
	'Andrásfa',
	'Annavölgy',
	'Apácatorna',
	'Apagy',
	'Apaj',
	'Aparhant',
	'Apátfalva',
	'Apátistvánfalva',
	'Apátvarasd',
	'Apc',
	'Áporka',
	'Apostag',
	'Aranyosapáti',
	'Aranyosgadány',
	'Arka',
	'Arló',
	'Arnót',
	'Ároktő',
	'Árpádhalom',
	'Árpás',
	'Ártánd',
	'Ásotthalom',
	'Ásványráró',
	'Aszaló',
	'Ászár',
	'Aszód',
	'Aszófő',
	'Áta',
	'Átány',
	'Atkár',
	'Attala',
	'Babarc',
	'Babarcszőlős',
	'Babócsa',
	'Bábolna',
	'Bábonymegyer',
	'Babosdöbréte',
	'Babót',
	'Bácsalmás',
	'Bácsbokod',
	'Bácsborsód',
	'Bácsszentgyörgy',
	'Bácsszőlős',
	'Badacsonytomaj',
	'Badacsonytördemic',
	'Bag',
	'Bagamér',
	'Baglad',
	'Bagod',
	'Bágyogszovát',
	'Baj',
	'Baja',
	'Bajánsenye',
	'Bajna',
	'Bajót',
	'Bak',
	'Bakháza',
	'Bakóca',
	'Bakonszeg',
	'Bakonya',
	'Bakonybánk',
	'Bakonybél',
	'Bakonygyirót',
	'Bakonyjákó',
	'Bakonykoppány',
	'Bakonykúti',
	'Bakonynána',
	'Bakonyoszlop',
	'Bakonypéterd',
	'Bakonypölöske',
	'Bakonyság',
	'Bakonysárkány',
	'Bakonyszentiván',
	'Bakonyszentkirály',
	'Bakonyszentlászló',
	'Bakonyszombathely',
	'Bakonyszücs',
	'Bakonytamási',
	'Baks',
	'Baksa',
	'Baktakék',
	'Baktalórántháza',
	'Baktüttös',
	'Balajt',
	'Balassagyarmat',
	'Balástya',
	'Balaton',
	'Balatonakali',
	'Balatonalmádi',
	'Balatonberény',
	'Balatonboglár',
	'Balatoncsicsó',
	'Balatonederics',
	'Balatonendréd',
	'Balatonfenyves',
	'Balatonfőkajár',
	'Balatonföldvár',
	'Balatonfüred',
	'Balatonfűzfő',
	'Balatongyörök',
	'Balatonhenye',
	'Balatonkenese',
	'Balatonkeresztúr',
	'Balatonlelle',
	'Balatonmagyaród',
	'Balatonmáriafürdő',
	'Balatonőszöd',
	'Balatonrendes',
	'Balatonszabadi',
	'Balatonszárszó',
	'Balatonszemes',
	'Balatonszentgyörgy',
	'Balatonszepezd',
	'Balatonszőlős',
	'Balatonudvari',
	'Balatonújlak',
	'Balatonvilágos',
	'Balinka',
	'Balkány',
	'Ballószög',
	'Balmazújváros',
	'Balogunyom',
	'Balotaszállás',
	'Balsa',
	'Bálványos',
	'Bana',
	'Bánd',
	'Bánfa',
	'Bánhorváti',
	'Bánk',
	'Bánokszentgyörgy',
	'Bánréve',
	'Bár',
	'Barabás',
	'Baracs',
	'Baracska',
	'Báránd',
	'Baranyahídvég',
	'Baranyajenő',
	'Baranyaszentgyörgy',
	'Barbacs',
	'Barcs',
	'Bárdudvarnok',
	'Barlahida',
	'Bárna',
	'Barnag',
	'Bársonyos',
	'Basal',
	'Baskó',
	'Báta',
	'Bátaapáti',
	'Bátaszék',
	'Baté',
	'Bátmonostor',
	'Bátonyterenye',
	'Bátor',
	'Bátorliget',
	'Battonya',
	'Bátya',
	'Batyk',
	'Bázakerettye',
	'Bazsi',
	'Béb',
	'Becsehely',
	'Becske',
	'Becskeháza',
	'Becsvölgye',
	'Bedegkér',
	'Bedő',
	'Bejcgyertyános',
	'Békás',
	'Bekecs',
	'Békés',
	'Békéscsaba',
	'Békéssámson',
	'Békésszentandrás',
	'Bekölce',
	'Bélapátfalva',
	'Bélavár',
	'Belecska',
	'Beled',
	'Beleg',
	'Belezna',
	'Bélmegyer',
	'Beloiannisz',
	'Belsősárd',
	'Belvárdgyula',
	'Benk',
	'Bénye',
	'Bér',
	'Bérbaltavár',
	'Bercel',
	'Beregdaróc',
	'Beregsurány',
	'Berekböszörmény',
	'Berekfürdő',
	'Beremend',
	'Berente',
	'Beret',
	'Berettyóújfalu',
	'Berhida',
	'Berkenye',
	'Berkesd',
	'Berkesz',
	'Bernecebaráti',
	'Berzék',
	'Berzence',
	'Besence',
	'Besenyőd',
	'Besenyőtelek',
	'Besenyszög',
	'Besnyő',
	'Beszterec',
	'Bezedek',
	'Bezenye',
	'Bezeréd',
	'Bezi',
	'Biatorbágy',
	'Bicsérd',
	'Bicske',
	'Bihardancsháza',
	'Biharkeresztes',
	'Biharnagybajom',
	'Bihartorda',
	'Biharugra',
	'Bikács',
	'Bikal',
	'Biri',
	'Birján',
	'Bisse',
	'Boba',
	'Bocfölde',
	'Boconád',
	'Bócsa',
	'Bocska',
	'Bocskaikert',
	'Boda',
	'Bodajk',
	'Bodmér',
	'Bodolyabér',
	'Bodonhely',
	'Bodony',
	'Bodorfa',
	'Bodrog',
	'Bodroghalom',
	'Bodrogkeresztúr',
	'Bodrogkisfalud',
	'Bodrogolaszi',
	'Bódvalenke',
	'Bódvarákó',
	'Bódvaszilas',
	'Bogács',
	'Bogád',
	'Bogádmindszent',
	'Bogdása',
	'Bogyiszló',
	'Bogyoszló',
	'Bojt',
	'Bókaháza',
	'Bokod',
	'Bokor',
	'Boldog',
	'Boldogasszonyfa',
	'Boldogkőújfalu',
	'Boldogkőváralja',
	'Boldva',
	'Bolhás',
	'Bolhó',
	'Boncodfölde',
	'Bonyhád',
	'Bonyhádvarasd',
	'Bonnya',
	'Bordány',
	'Borgáta',
	'Borjád',
	'Borota',
	'Borsfa',
	'Borsodbóta',
	'Borsodgeszt',
	'Borsodivánka',
	'Borsodnádasd',
	'Borsodszentgyörgy',
	'Borsodszirák',
	'Borsosberény',
	'Borzavár',
	'Bosta',
	'Botpalád',
	'Botykapeterd',
	'Bozzai',
	'Bozsok',
	'Bózsva',
	'Bő',
	'Bőcs',
	'Böde',
	'Bödeháza',
	'Bögöt',
	'Bögöte',
	'Böhönye',
	'Bököny',
	'Bölcske',
	'Bőny',
	'Börcs',
	'Börzönce',
	'Bősárkány',
	'Bőszénfa',
	'Bucsa',
	'Bucsu',
	'Búcsúszentlászló',
	'Bucsuta',
	'Budajenő',
	'Budakalász',
	'Budakeszi',
	'Budaörs',
	'Bugac',
	'Bugacpusztaháza',
	'Bugyi',
	'Buj',
	'Buják',
	'Buzsák',
	'Bük',
	'Bükkábrány',
	'Bükkaranyos',
	'Bükkmogyorósd',
	'Bükkösd',
	'Bükkszék',
	'Bükkszenterzsébet',
	'Bükkszentkereszt',
	'Bükkszentmárton',
	'Bükkzsérc',
	'Bürüs',
	'Büssü',
	'Büttös',
	'Cák',
	'Cakóháza',
	'Cece',
	'Cégénydányád',
	'Cegléd',
	'Ceglédbercel',
	'Celldömölk',
	'Cered',
	'Chernelházadamonya',
	'Cibakháza',
	'Cigánd',
	'Cikó',
	'Cirák',
	'Cún',
	'Csabacsűd',
	'Csabaszabadi',
	'Csabdi',
	'Csabrendek',
	'Csáfordjánosfa',
	'Csaholc',
	'Csajág',
	'Csákány',
	'Csákánydoroszló',
	'Csákberény',
	'Csákvár',
	'Csanádalberti',
	'Csanádapáca',
	'Csanádpalota',
	'Csánig',
	'Csány',
	'Csányoszró',
	'Csanytelek',
	'Csapi',
	'Csapod',
	'Csárdaszállás',
	'Csarnóta',
	'Csaroda',
	'Császár',
	'Császártöltés',
	'Császló',
	'Csátalja',
	'Csatár',
	'Csataszög',
	'Csatka',
	'Csávoly',
	'Csebény',
	'Csécse',
	'Csegöld',
	'Csehbánya',
	'Csehi',
	'Csehimindszent',
	'Csém',
	'Csemő',
	'Csempeszkopács',
	'Csengele',
	'Csenger',
	'Csengersima',
	'Csengerújfalu',
	'Csengőd',
	'Csénye',
	'Csenyéte',
	'Csép',
	'Csépa',
	'Csepreg',
	'Csér',
	'Cserdi',
	'Cserénfa',
	'Cserépfalu',
	'Cserépváralja',
	'Cserháthaláp',
	'Cserhátsurány',
	'Cserhátszentiván',
	'Cserkeszőlő',
	'Cserkút',
	'Csernely',
	'Cserszegtomaj',
	'Csertalakos',
	'Csertő',
	'Csesznek',
	'Csesztreg',
	'Csesztve',
	'Csetény',
	'Csévharaszt',
	'Csibrák',
	'Csikéria',
	'Csikóstőttős',
	'Csikvánd',
	'Csincse',
	'Csipkerek',
	'Csitár',
	'Csobád',
	'Csobaj',
	'Csobánka',
	'Csókakő',
	'Csokonyavisonta',
	'Csokvaomány',
	'Csolnok',
	'Csólyospálos',
	'Csoma',
	'Csomád',
	'Csombárd',
	'Csongrád',
	'Csonkahegyhát',
	'Csonkamindszent',
	'Csopak',
	'Csór',
	'Csorna',
	'Csorvás',
	'Csót',
	'Csöde',
	'Csögle',
	'Csökmő',
	'Csököly',
	'Csömend',
	'Csömödér',
	'Csömör',
	'Csönge',
	'Csörnyeföld',
	'Csörög',
	'Csörötnek',
	'Csősz',
	'Csővár',
	'Csurgó',
	'Csurgónagymarton',
	'Dabas',
	'Dabronc',
	'Dabrony',
	'Dad',
	'Dág',
	'Dáka',
	'Dalmand',
	'Damak',
	'Dámóc',
	'Dánszentmiklós',
	'Dány',
	'Daraboshegy',
	'Darány',
	'Darnó',
	'Darnózseli',
	'Daruszentmiklós',
	'Darvas',
	'Dávod',
	'Debercsény',
	'Debrecen',
	'Debréte',
	'Decs',
	'Dédestapolcsány',
	'Dég',
	'Dejtár',
	'Délegyháza',
	'Demecser',
	'Demjén',
	'Dencsháza',
	'Dénesfa',
	'Derecske',
	'Derekegyház',
	'Deszk',
	'Detek',
	'Detk',
	'Dévaványa',
	'Devecser',
	'Dinnyeberki',
	'Diósberény',
	'Diósd',
	'Diósjenő',
	'Dióskál',
	'Diósviszló',
	'Doboz',
	'Dobri',
	'Dobronhegy',
	'Dóc',
	'Domaháza',
	'Domaszék',
	'Dombegyház',
	'Dombiratos',
	'Dombóvár',
	'Dombrád',
	'Domony',
	'Domoszló',
	'Dormánd',
	'Dorog',
	'Dorogháza',
	'Dozmat',
	'Döbörhegy',
	'Döbröce',
	'Döbrököz',
	'Döbrönte',
	'Döge',
	'Dömös',
	'Dömsöd',
	'Dör',
	'Dörgicse',
	'Döröske',
	'Dötk',
	'Dövény',
	'Drágszél',
	'Drávacsehi',
	'Drávacsepely',
	'Drávafok',
	'Drávagárdony',
	'Drávaiványi',
	'Drávakeresztúr',
	'Drávapalkonya',
	'Drávapiski',
	'Drávaszabolcs',
	'Drávaszerdahely',
	'Drávasztára',
	'Drávatamási',
	'Drégelypalánk',
	'Dubicsány',
	'Dudar',
	'Duka',
	'Dunaalmás',
	'Dunabogdány',
	'Dunaegyháza',
	'Dunafalva',
	'Dunaföldvár',
	'Dunaharaszti',
	'Dunakeszi',
	'Dunakiliti',
	'Dunapataj',
	'Dunaremete',
	'Dunaszeg',
	'Dunaszekcső',
	'Dunaszentbenedek',
	'Dunaszentgyörgy',
	'Dunaszentmiklós',
	'Dunaszentpál',
	'Dunasziget',
	'Dunatetétlen',
	'Dunaújváros',
	'Dunavarsány',
	'Dunavecse',
	'Dusnok',
	'Dúzs',
	'Ebergőc',
	'Ebes',
	'Écs',
	'Ecséd',
	'Ecseg',
	'Ecsegfalva',
	'Ecseny',
	'Ecser',
	'Edde',
	'Edelény',
	'Edve',
	'Eger',
	'Egerág',
	'Egeralja',
	'Egeraracsa',
	'Egerbakta',
	'Egerbocs',
	'Egercsehi',
	'Egerfarmos',
	'Egerlövő',
	'Egerszalók',
	'Egerszólát',
	'Égerszög',
	'Egervár',
	'Egervölgy',
	'Egyed',
	'Egyek',
	'Egyházasdengeleg',
	'Egyházasfalu',
	'Egyházasgerge',
	'Egyházasharaszti',
	'Egyházashetye',
	'Egyházashollós',
	'Egyházaskesző',
	'Egyházaskozár',
	'Egyházasrádóc',
	'Elek',
	'Ellend',
	'Előszállás',
	'Emőd',
	'Encs',
	'Encsencs',
	'Endrefalva',
	'Endrőc',
	'Enese',
	'Enying',
	'Eperjes',
	'Eperjeske',
	'Eplény',
	'Epöl',
	'Ercsi',
	'Érd',
	'Erdőbénye',
	'Erdőhorváti',
	'Erdőkertes',
	'Erdőkövesd',
	'Erdőkürt',
	'Erdősmárok',
	'Erdősmecske',
	'Erdőtarcsa',
	'Erdőtelek',
	'Erk',
	'Érpatak',
	'Érsekcsanád',
	'Érsekhalma',
	'Érsekvadkert',
	'Értény',
	'Erzsébet',
	'Esztár',
	'Eszteregnye',
	'Esztergályhorváti',
	'Esztergom',
	'Ete',
	'Etes',
	'Etyek',
	'Fábiánháza',
	'Fábiánsebestyén',
	'Fácánkert',
	'Fadd',
	'Fáj',
	'Fajsz',
	'Fancsal',
	'Farád',
	'Farkasgyepű',
	'Farkaslyuk',
	'Farmos',
	'Fazekasboda',
	'Fedémes',
	'Fegyvernek(Szapárfalu)',
	'Fehérgyarmat',
	'Fehértó',
	'Fehérvárcsurgó',
	'Feked',
	'Feketeerdő',
	'Felcsút',
	'Feldebrő',
	'Felgyő',
	'Felpéc',
	'Felsőberecki',
	'Felsőcsatár',
	'Felsődobsza',
	'Felsőegerszeg',
	'Felsőgagy',
	'Felsőjánosfa',
	'Felsőkelecsény',
	'Felsőlajos',
	'Felsőmarác',
	'Felsőmocsolád',
	'Felsőnána',
	'Felsőnyárád',
	'Felsőnyék',
	'Felsőörs',
	'Felsőpáhok',
	'Felsőpakony',
	'Felsőpetény',
	'Felsőrajk',
	'Felsőregmec',
	'Felsőszenterzsébet',
	'Felsőszentiván',
	'Felsőszentmárton',
	'Felsőszölnök',
	'Felsőtárkány',
	'Felsőtelekes',
	'Felsőtold',
	'Felsővadász',
	'Felsőzsolca',
	'Fényeslitke',
	'Fenyőfő',
	'Ferencszállás',
	'Fertőboz',
	'Fertőd',
	'Fertőendréd',
	'Fertőhomok',
	'Fertőrákos',
	'Fertőszentmiklós',
	'Fertőszéplak',
	'Fiad',
	'Filkeháza',
	'Fityeház',
	'Foktő',
	'Folyás',
	'Fonó',
	'Fony',
	'Fonyód',
	'Forráskút',
	'Forró',
	'Fót',
	'Földeák',
	'Földes',
	'Főnyed',
	'Fulókércs',
	'Furta',
	'Füle',
	'Fülesd',
	'Fülöp',
	'Fülöpháza',
	'Fülöpjakab',
	'Fülöpszállás',
	'Fülpösdaróc',
	'Fürged',
	'Füzér',
	'Füzérkajata',
	'Füzérkomlós',
	'Füzérradvány',
	'Füzesabony',
	'Füzesgyarmat',
	'Fűzvölgy',
	'Gáborján',
	'Gáborjánháza',
	'Gacsály',
	'Gadács',
	'Gadány',
	'Gadna',
	'Gádoros',
	'Gagyapáti',
	'Gagybátor',
	'Gagyvendégi',
	'Galambok',
	'Galgaguta',
	'Galgagyörk',
	'Galgahévíz',
	'Galgamácsa',
	'Gálosfa',
	'Galvács',
	'Gamás',
	'Ganna',
	'Gánt',
	'Gara',
	'Garáb',
	'Garabonc',
	'Garadna',
	'Garbolc',
	'Gárdony',
	'Garé',
	'Gasztony',
	'Gátér',
	'Gávavencsellő',
	'Géberjén',
	'Gecse',
	'Géderlak',
	'Gégény',
	'Gelej',
	'Gelénes',
	'Gellénháza',
	'Gelse',
	'Gelsesziget',
	'Gemzse',
	'Gencsapáti',
	'Gérce',
	'Gerde',
	'Gerendás',
	'Gerényes',
	'Geresdlak',
	'Gerjen',
	'Gersekarát',
	'Geszt',
	'Gesztely',
	'Geszteréd',
	'Gétye',
	'Gibárt',
	'Gic',
	'Gige',
	'Gilvánfa',
	'Girincs',
	'Gógánfa',
	'Golop',
	'Gomba',
	'Gombosszeg',
	'Gór',
	'Gordisa',
	'Gosztola',
	'Göd',
	'Gödöllő',
	'Gödre',
	'Gölle',
	'Gömörszőlős',
	'Gönc',
	'Göncruszka',
	'Gönyű',
	'Görbeháza',
	'Görcsöny',
	'Görcsönydoboka',
	'Görgeteg',
	'Gősfa',
	'Grábóc',
	'Gulács',
	'Gutorfölde',
	'Gyál',
	'Gyalóka',
	'Gyanógeregye',
	'Gyarmat',
	'Gyékényes',
	'Gyenesdiás',
	'Gyepükaján',
	'Gyermely',
	'Gyód',
	'Gyomaendrőd',
	'Gyóró',
	'Gyömöre',
	'Gyömrő',
	'Gyöngyfa',
	'Gyöngyös',
	'Gyöngyösfalu',
	'Gyöngyöshalász',
	'Gyöngyösmellék',
	'Gyöngyösoroszi',
	'Gyöngyöspata',
	'Gyöngyössolymos',
	'Gyöngyöstarján',
	'Gyönk',
	'Győr',
	'Győrasszonyfa',
	'Györe',
	'Györgytarló',
	'Györköny',
	'Győrladamér',
	'Győröcske',
	'Győrság',
	'Győrsövényház',
	'Győrszemere',
	'Győrtelek',
	'Győrújbarát',
	'Győrújfalu',
	'Győrvár',
	'Győrzámoly',
	'Gyugy',
	'Gyula',
	'Gyulaháza',
	'Gyulaj',
	'Gyulakeszi',
	'Gyúró',
	'Gyügye',
	'Gyüre',
	'Gyűrűs',
	'Hács',
	'Hagyárosbörönd',
	'Hahót',
	'Hajdúbagos',
	'Hajdúböszörmény',
	'Hajdúdorog',
	'Hajdúhadház',
	'Hajdúnánás',
	'Hajdúsámson',
	'Hajdúszoboszló',
	'Hajdúszovát',
	'Hajmás',
	'Hajmáskér',
	'Hajós',
	'Halastó',
	'Halászi',
	'Halásztelek',
	'Halimba',
	'Halmaj',
	'Halmajugra',
	'Halogy',
	'Hangács',
	'Hangony',
	'Hantos',
	'Harasztifalu',
	'Harc',
	'Harka',
	'Harkakötöny',
	'Harkány',
	'Háromfa',
	'Háromhuta',
	'Harsány',
	'Hárskút',
	'Harta',
	'Hásságy',
	'Hatvan',
	'Hédervár',
	'Hedrehely',
	'Hegyesd',
	'Hegyeshalom',
	'Hegyfalu',
	'Hegyháthodász',
	'Hegyhátmaróc',
	'Hegyhátsál',
	'Hegyhátszentjakab',
	'Hegyhátszentmárton',
	'Hegyhátszentpéter',
	'Hegykő',
	'Hegymagas',
	'Hegymeg',
	'Hegyszentmárton',
	'Héhalom',
	'Hejce',
	'Hejőbába',
	'Hejőkeresztúr',
	'Hejőkürt',
	'Hejőpapi',
	'Hejőszalonta',
	'Helesfa',
	'Helvécia',
	'Hencida',
	'Hencse',
	'Herceghalom',
	'Hercegkút',
	'Hercegszántó',
	'Heréd',
	'Héreg',
	'Herencsény',
	'Herend',
	'Heresznye',
	'Hermánszeg',
	'Hernád',
	'Hernádbűd',
	'Hernádcéce',
	'Hernádkak',
	'Hernádkércs',
	'Hernádnémeti',
	'Hernádpetri',
	'Hernádszentandrás',
	'Hernádszurdok',
	'Hernádvécse',
	'Hernyék',
	'Hét',
	'Hetefejércse',
	'Hetes',
	'Hetvehely',
	'Hetyefő',
	'Heves',
	'Hevesaranyos',
	'Hevesvezekény',
	'Hévíz',
	'Hévízgyörk',
	'Hidas',
	'Hidasnémeti',
	'Hidegkút',
	'Hidegség',
	'Hidvégardó',
	'Himesháza',
	'Himod',
	'Hirics',
	'Hobol',
	'Hodász',
	'Hódmezővásárhely',
	'Hollád',
	'Hollóháza',
	'Hollókő',
	'Homokbödöge',
	'Homokkomárom',
	'Homokmégy',
	'Homokszentgyörgy',
	'Homorúd',
	'Homrogd',
	'Hont',
	'Horpács',
	'Hort',
	'Horváthertelend',
	'Horvátlövő',
	'Horvátzsidány',
	'Hosszúhetény',
	'Hosszúpályi',
	'Hosszúpereszteg',
	'Hosszúvíz',
	'Hosszúvölgy',
	'Hosztót',
	'Hottó',
	'Hőgyész',
	'Hövej',
	'Hugyag',
	'Hunya',
	'Hunyadfalva',
	'Husztót',
	'Ibafa',
	'Iborfia',
	'Ibrány',
	'Igal',
	'Igar',
	'Igrici',
	'Iharos',
	'Iharosberény',
	'Ikervár',
	'Iklad',
	'Iklanberény',
	'Iklódbördőce',
	'Ikrény',
	'Iliny',
	'Ilk',
	'Illocska',
	'Imola',
	'Imrehegy',
	'Ináncs',
	'Inárcs',
	'Inke',
	'Ipacsfa',
	'Ipolydamásd',
	'Ipolyszög',
	'Ipolytarnóc',
	'Ipolytölgyes',
	'Ipolyvece',
	'Iregszemcse',
	'Irota',
	'Isaszeg',
	'Ispánk',
	'Istenmezeje',
	'Istvándi',
	'Iszkaszentgyörgy',
	'Iszkáz',
	'Isztimér',
	'Ivád',
	'Iván',
	'Ivánbattyán',
	'Ivánc',
	'Iváncsa',
	'Ivándárda',
	'Izmény',
	'Izsák',
	'Izsófalva',
	'Jágónak',
	'Ják',
	'Jakabszállás',
	'Jákfa',
	'Jákfalva',
	'Jákó',
	'Jánd',
	'Jánkmajtis',
	'Jánoshalma',
	'Jánosháza',
	'Jánoshida',
	'Jánossomorja',
	'Járdánháza',
	'Jármi',
	'Jásd',
	'Jászágó',
	'Jászalsószentgyörgy',
	'Jászapáti',
	'Jászárokszállás',
	'Jászberény',
	'Jászboldogháza',
	'Jászdózsa',
	'Jászfelsőszentgyörgy',
	'Jászfényszaru',
	'Jászivány',
	'Jászjákóhalma',
	'Jászkarajenő',
	'Jászkisér',
	'Jászladány',
	'Jászszentandrás',
	'Jászszentlászló',
	'Jásztelek',
	'Jéke',
	'Jenő',
	'Jobaháza',
	'Jobbágyi',
	'Jósvafő',
	'Juta',
	'Kaba',
	'Kacorlak',
	'Kács',
	'Kacsóta',
	'Kadarkút',
	'Kajárpéc',
	'Kajászó',
	'Kajdacs',
	'Kakasd',
	'Kákics',
	'Kakucs',
	'Kál',
	'Kalaznó',
	'Káld',
	'Kálló',
	'Kallósd',
	'Kállósemjén',
	'Kálmáncsa',
	'Kálmánháza',
	'Kálócfa',
	'Kalocsa',
	'Káloz',
	'Kám',
	'Kamond',
	'Kamut',
	'Kánó',
	'Kántorjánosi',
	'Kány',
	'Kánya',
	'Kányavár',
	'Kapolcs',
	'Kápolna',
	'Kápolnásnyék',
	'Kapoly',
	'Kaposfő',
	'Kaposgyarmat',
	'Kaposhomok',
	'Kaposkeresztúr',
	'Kaposmérő',
	'Kapospula',
	'Kaposújlak',
	'Kaposvár',
	'Kaposszekcső',
	'Kaposszerdahely',
	'Káptalanfa',
	'Káptalantóti',
	'Kapuvár',
	'Kára',
	'Karácsond',
	'Karád',
	'Karakó',
	'Karakószörcsök',
	'Karancsalja',
	'Karancsberény',
	'Karancskeszi',
	'Karancslapujtő',
	'Karancsság',
	'Kárász',
	'Karcag',
	'Karcsa',
	'Kardos',
	'Kardoskút',
	'Karmacs',
	'Károlyháza',
	'Karos',
	'Kartal',
	'Kásád',
	'Kaskantyú',
	'Kastélyosdombó',
	'Kaszaper',
	'Kaszó',
	'Katádfa',
	'Katafa',
	'Kátoly',
	'Katymár',
	'Káva',
	'Kávás',
	'Kazár',
	'Kazincbarcika',
	'Kázsmárk',
	'Kazsok',
	'Kecel',
	'Kecskéd',
	'Kecskemét',
	'Kehidakustány',
	'Kék',
	'Kékcse',
	'Kéked',
	'Kékesd',
	'Kékkút',
	'Kelebia',
	'Keléd',
	'Kelemér',
	'Kéleshalom',
	'Kelevíz',
	'Kemecse',
	'Kemence',
	'Kemendollár',
	'Kemeneshőgyész',
	'Kemeneskápolna',
	'Kemenesmagasi',
	'Kemenesmihályfa',
	'Kemenespálfa',
	'Kemenessömjén',
	'Kemenesszentmárton',
	'Kemenesszentpéter',
	'Keménfa',
	'Kémes',
	'Kemestaródfa',
	'Kemse',
	'Kenderes',
	'Kenéz',
	'Kenézlő',
	'Kengyel',
	'Kenyeri',
	'Kercaszomor',
	'Kercseliget',
	'Kerecsend',
	'Kerecseny',
	'Kerekegyháza',
	'Kerekharaszt',
	'Kereki',
	'Kerékteleki',
	'Kerepes',
	'Keresztéte',
	'Kerkabarabás',
	'Kerkafalva',
	'Kerkakutas',
	'Kerkáskápolna',
	'Kerkaszentkirály',
	'Kerkateskánd',
	'Kérsemjén',
	'Kerta',
	'Kertészsziget',
	'Keszeg',
	'Kesznyéten',
	'Keszőhidegkút',
	'Keszthely',
	'Kesztölc',
	'Keszü',
	'Kétbodony',
	'Kétegyháza',
	'Kéthely',
	'Kétpó',
	'Kétsoprony',
	'Kétújfalu',
	'Kétvölgy',
	'Kéty',
	'Kevermes',
	'Kilimán',
	'Kimle',
	'Kincsesbánya',
	'Királd',
	'Királyegyháza',
	'Királyhegyes',
	'Királyszentistván',
	'Kisapáti',
	'Kisapostag',
	'Kisar',
	'Kisasszond',
	'Kisasszonyfa',
	'Kisbabot',
	'Kisbágyon',
	'Kisbajcs',
	'Kisbajom',
	'Kisbárapáti',
	'Kisbárkány',
	'Kisbér',
	'Kisberény',
	'Kisberzseny',
	'Kisbeszterce',
	'Kisbodak',
	'Kisbucsa',
	'Kisbudmér',
	'Kiscsécs',
	'Kiscsehi',
	'Kiscsősz',
	'Kisdér',
	'Kisdobsza',
	'Kisdombegyház',
	'Kisdorog',
	'Kisecset',
	'Kisfalud',
	'Kisfüzes',
	'Kisgörbő',
	'Kisgyalán',
	'Kisgyőr',
	'Kishajmás',
	'Kisharsány',
	'Kishartyán',
	'Kisherend',
	'Kishódos',
	'Kishuta',
	'Kisigmánd',
	'Kisjakabfalva',
	'Kiskassa',
	'Kiskinizs',
	'Kiskorpád',
	'Kisköre',
	'Kiskőrös',
	'Kiskunfélegyháza',
	'Kiskunhalas',
	'Kiskunlacháza',
	'Kiskunmajsa',
	'Kiskutas',
	'Kisláng',
	'Kisléta',
	'Kislippó',
	'Kislőd',
	'Kismányok',
	'Kismarja',
	'Kismaros',
	'Kisnamény',
	'Kisnána',
	'Kisnémedi',
	'Kisnyárád',
	'Kisoroszi',
	'Kispalád',
	'Kispáli',
	'Kispirit',
	'Kisrákos',
	'Kisrécse',
	'Kisrozvágy',
	'Kissikátor',
	'Kissomlyó',
	'Kistamási',
	'Kistapolca',
	'Kistarcsa',
	'Kistelek',
	'Kistokaj',
	'Kistolmács',
	'Kistormás',
	'Kistótfalu',
	'Kisújszállás',
	'Kisunyom',
	'Kisvárda',
	'Kisvarsány',
	'Kisvásárhely',
	'Kisvaszar',
	'Kisvejke',
	'Kiszombor',
	'Kiszsidány',
	'Kisszállás',
	'Kisszékely',
	'Kisszekeres',
	'Kisszentmárton',
	'Kissziget',
	'Kisszőlős',
	'Klárafalva',
	'Kocs',
	'Kocsér',
	'Kocsola',
	'Kocsord',
	'Kóka',
	'Kokad',
	'Kolontár',
	'Komádi',
	'Komárom',
	'Komjáti',
	'Komlódtótfalu',
	'Komlósd',
	'Komlóska',
	'Komoró',
	'Kompolt',
	'Kondó',
	'Kondorfa',
	'Kondoros',
	'Kóny',
	'Konyár',
	'Kópháza',
	'Koppányszántó',
	'Korlát',
	'Koroncó',
	'Kórós',
	'Kosd',
	'Kóspallag',
	'Kótaj',
	'Kovácshida',
	'Kovácsszénája',
	'Kovácsvágás',
	'Kozárd',
	'Kozmadombja',
	'Köblény',
	'Köcsk',
	'Kökény',
	'Kőkút',
	'Kölcse',
	'Kölesd',
	'Kölked',
	'Kömlő',
	'Kömlőd',
	'Kömörő',
	'Kömpöc',
	'Körmend',
	'Környe',
	'Köröm',
	'Kőröshegy',
	'Körösladány',
	'Körösnagyharsány',
	'Köröstarcsa',
	'Kőröstetétlen',
	'Körösújfalu',
	'Körösszakál',
	'Körösszegapáti',
	'Kőszárhegy',
	'Kőszeg',
	'Kőszegdoroszló',
	'Kőszegpaty',
	'Kőszegszerdahely',
	'Kötcse',
	'Kötegyán',
	'Kőtelek',
	'Kővágóörs',
	'Kővágószőlős',
	'Kővágótöttös',
	'Kövegy',
	'Köveskál',
	'Krasznokvajda',
	'Kulcs',
	'Kunadacs',
	'Kunágota',
	'Kunbaja',
	'Kunbaracs',
	'Kuncsorba',
	'Kunfehértó',
	'Kunhegyes',
	'Kunmadaras',
	'Kunpeszér',
	'Kunszállás',
	'Kunszentmárton',
	'Kunszentmiklós',
	'Kunsziget',
	'Kup',
	'Kupa',
	'Kurd',
	'Kurityán',
	'Kustánszeg',
	'Kutas',
	'Kutasó',
	'Kübekháza',
	'Külsősárd',
	'Külsővat',
	'Küngös',
	'Lábatlan',
	'Lábod',
	'Lácacséke',
	'Lad',
	'Ladánybene',
	'Ládbesenyő',
	'Lajoskomárom',
	'Lajosmizse',
	'Lak',
	'Lakhegy',
	'Lakitelek',
	'Lakócsa',
	'Lánycsók',
	'Lápafő',
	'Lapáncsa',
	'Laskod',
	'Lasztonya',
	'Látrány',
	'Lázi',
	'Leányfalu',
	'Leányvár',
	'Lébény',
	'Legénd',
	'Legyesbénye',
	'Léh',
	'Lénárddaróc',
	'Lendvadedes',
	'Lendvajakabfa',
	'Lengyel',
	'Lengyeltóti',
	'Lenti',
	'Lepsény',
	'Lesencefalu',
	'Lesenceistvánd',
	'Lesencetomaj',
	'Létavértes',
	'Letenye',
	'Letkés',
	'Levél',
	'Levelek',
	'Libickozma',
	'Lickóvadamos',
	'Liget',
	'Ligetfalva',
	'Lipót',
	'Lippó',
	'Liptód',
	'Lispeszentadorján',
	'Liszó',
	'Litér',
	'Litka',
	'Litke',
	'Lócs',
	'Lókút',
	'Lónya',
	'Lórév',
	'Lothárd',
	'Lovas',
	'Lovasberény',
	'Lovászhetény',
	'Lovászi',
	'Lovászpatona',
	'Lőkösháza',
	'Lőrinci',
	'Lövő',
	'Lövőpetri',
	'Lucfalva',
	'Ludányhalászi',
	'Ludas',
	'Lukácsháza',
	'Lulla',
	'Lúzsok',
	'Mád',
	'Madaras',
	'Madocsa',
	'Maglóca',
	'Maglód',
	'Mágocs',
	'Magosliget',
	'Magy',
	'Magyaralmás',
	'Magyaratád',
	'Magyarbánhegyes',
	'Magyarbóly',
	'Magyarcsanád',
	'Magyardombegyház',
	'Magyaregregy',
	'Magyaregres',
	'Magyarföld',
	'Magyargéc',
	'Magyargencs',
	'Magyarhertelend',
	'Magyarhomorog',
	'Magyarkeresztúr',
	'Magyarkeszi',
	'Magyarlak',
	'Magyarlukafa',
	'Magyarmecske',
	'Magyarnádalja',
	'Magyarnándor',
	'Magyarpolány',
	'Magyarsarlós',
	'Magyarszecsőd',
	'Magyarszék',
	'Magyarszentmiklós',
	'Magyarszerdahely',
	'Magyarszombatfa',
	'Magyartelek',
	'Majosháza',
	'Majs',
	'Makád',
	'Makkoshotyka',
	'Maklár',
	'Makó',
	'Malomsok',
	'Mályi',
	'Mályinka',
	'Mánd',
	'Mándok',
	'Mánfa',
	'Mány',
	'Maráza',
	'Marcalgergelyi',
	'Marcali',
	'Marcaltő',
	'Márfa',
	'Máriahalom',
	'Máriakálnok',
	'Máriakéménd',
	'Márianosztra',
	'Máriapócs',
	'Markaz',
	'Márkháza',
	'Márkó',
	'Markóc',
	'Markotabödöge',
	'Maróc',
	'Marócsa',
	'Márok',
	'Márokföld',
	'Márokpapi',
	'Maroslele',
	'Mártély',
	'Martfű',
	'Martonfa',
	'Martonvásár',
	'Martonyi',
	'Mátészalka',
	'Mátételke',
	'Mátraballa',
	'Mátraderecske',
	'Mátramindszent',
	'Mátranovák',
	'Mátraszele',
	'Mátraszentimre',
	'Mátraszőlős',
	'Mátraterenye',
	'Mátraverebély',
	'Mátyásdomb',
	'Matty',
	'Mátyus',
	'Máza',
	'Mecseknádasd',
	'Mecsekpölöske',
	'Mecsér',
	'Medgyesbodzás',
	'Medgyesegyháza',
	'Medina',
	'Megyaszó',
	'Megyehíd',
	'Megyer',
	'Meggyeskovácsi',
	'Méhkerék',
	'Méhtelek',
	'Mekényes',
	'Mélykút',
	'Mencshely',
	'Mende',
	'Méra',
	'Merenye',
	'Mérges',
	'Mérk',
	'Mernye',
	'Mersevát',
	'Mesterháza',
	'Mesteri',
	'Mesterszállás',
	'Meszes',
	'Meszlen',
	'Mesztegnyő',
	'Mezőberény',
	'Mezőcsát',
	'Mezőcsokonya',
	'Meződ',
	'Mezőfalva',
	'Mezőgyán',
	'Mezőhegyes',
	'Mezőhék',
	'Mezőkeresztes',
	'Mezőkomárom',
	'Mezőkovácsháza',
	'Mezőkövesd',
	'Mezőladány',
	'Mezőlak',
	'Mezőnagymihály',
	'Mezőnyárád',
	'Mezőörs',
	'Mezőpeterd',
	'Mezősas',
	'Mezőszemere',
	'Mezőszentgyörgy',
	'Mezőszilas',
	'Mezőtárkány',
	'Mezőtúr',
	'Mezőzombor',
	'Miháld',
	'Mihályfa',
	'Mihálygerge',
	'Mihályháza',
	'Mihályi',
	'Mike',
	'Mikebuda',
	'Mikekarácsonyfa',
	'Mikepércs',
	'Miklósi',
	'Mikófalva',
	'Mikóháza',
	'Mikosszéplak',
	'Milejszeg',
	'Milota',
	'Mindszent',
	'Mindszentgodisa',
	'Mindszentkálla',
	'Misefa',
	'Miske',
	'Miskolc',
	'Miszla',
	'Mocsa',
	'Mogyoród',
	'Mogyorósbánya',
	'Mogyoróska',
	'Moha',
	'Mohács',
	'Mohora',
	'Molnári',
	'Molnaszecsőd',
	'Molvány',
	'Monaj',
	'Monok',
	'Monor',
	'Monorierdő',
	'Mónosbél',
	'Monostorapáti',
	'Monostorpályi',
	'Monoszló',
	'Monyoród',
	'Mór',
	'Mórágy',
	'Mórahalom',
	'Móricgát',
	'Mórichida',
	'Mosonmagyaróvár',
	'Mosonszentmiklós',
	'Mosonszolnok',
	'Mosonudvar',
	'Mozsgó',
	'Mőcsény',
	'Mucsfa',
	'Mucsi',
	'Múcsony',
	'Muhi',
	'Murakeresztúr',
	'Murarátka',
	'Muraszemenye',
	'Murga',
	'Murony',
	'Nábrád',
	'Nadap',
	'Nádasd',
	'Nádasdladány',
	'Nádudvar',
	'Nágocs',
	'Nagyacsád',
	'Nagyalásony',
	'Nagyar',
	'Nagyatád',
	'Nagybajcs',
	'Nagybajom',
	'Nagybakónak',
	'Nagybánhegyes',
	'Nagybaracska',
	'Nagybarca',
	'Nagybárkány',
	'Nagyberény',
	'Nagyberki',
	'Nagybörzsöny',
	'Nagybudmér',
	'Nagycenk',
	'Nagycsány',
	'Nagycsécs',
	'Nagycsepely',
	'Nagycserkesz',
	'Nagydém',
	'Nagydobos',
	'Nagydobsza',
	'Nagydorog',
	'Nagyecsed',
	'Nagyér',
	'Nagyesztergár',
	'Nagyfüged',
	'Nagygeresd',
	'Nagygörbő',
	'Nagygyimót',
	'Nagyhajmás',
	'Nagyhalász',
	'Nagyharsány',
	'Nagyhegyes',
	'Nagyhódos',
	'Nagyhuta',
	'Nagyigmánd',
	'Nagyiván',
	'Nagykálló',
	'Nagykamarás',
	'Nagykanizsa',
	'Nagykapornak',
	'Nagykarácsony',
	'Nagykáta',
	'Nagykereki',
	'Nagykeresztúr',
	'Nagykinizs',
	'Nagykónyi',
	'Nagykorpád',
	'Nagykovácsi',
	'Nagykozár',
	'Nagykökényes',
	'Nagykölked',
	'Nagykőrös',
	'Nagykörű',
	'Nagykutas',
	'Nagylak',
	'Nagylengyel',
	'Nagylóc',
	'Nagylók',
	'Nagylózs',
	'Nagymágocs',
	'Nagymányok',
	'Nagymaros',
	'Nagymizdó',
	'Nagynyárád',
	'Nagyoroszi',
	'Nagypáli',
	'Nagypall',
	'Nagypeterd',
	'Nagypirit',
	'Nagyrábé',
	'Nagyrada',
	'Nagyrákos',
	'Nagyrécse',
	'Nagyréde',
	'Nagyrév',
	'Nagyrozvágy',
	'Nagysáp',
	'Nagysimonyi',
	'Nagyszakácsi',
	'Nagyszékely',
	'Nagyszekeres',
	'Nagyszénás',
	'Nagyszentjános',
	'Nagyszokoly',
	'Nagytálya',
	'Nagytarcsa',
	'Nagytevel',
	'Nagytilaj',
	'Nagytótfalu',
	'Nagytőke',
	'Nagyút',
	'Nagyvarsány',
	'Nagyváty',
	'Nagyvázsony',
	'Nagyvejke',
	'Nagyveleg',
	'Nagyvenyim',
	'Nagyvisnyó',
	'Nak',
	'Napkor',
	'Nárai',
	'Narda',
	'Naszály',
	'Négyes',
	'Nekézseny',
	'Nemesapáti',
	'Nemesbikk',
	'Nemesborzova',
	'Nemesbőd',
	'Nemesbük',
	'Nemescsó',
	'Nemesdéd',
	'Nemesgörzsöny',
	'Nemesgulács',
	'Nemeshany',
	'Nemeshetés',
	'Nemeske',
	'Nemeskér',
	'Nemeskeresztúr',
	'Nemeskocs',
	'Nemeskolta',
	'Nemesládony',
	'Nemesmedves',
	'Nemesnádudvar',
	'Nemesnép',
	'Nemespátró',
	'Nemesrádó',
	'Nemesrempehollós',
	'Nemessándorháza',
	'Nemesvámos',
	'Nemesvid',
	'Nemesvita',
	'Nemesszalók',
	'Nemesszentandrás',
	'Németbánya',
	'Németfalu',
	'Németkér',
	'Nemti',
	'Neszmély',
	'Nézsa',
	'Nick',
	'Nikla',
	'Nógrád',
	'Nógrádkövesd',
	'Nógrádmarcal',
	'Nógrádmegyer',
	'Nógrádsáp',
	'Nógrádsipek',
	'Nógrádszakál',
	'Nóráp',
	'Noszlop',
	'Noszvaj',
	'Nova',
	'Novaj',
	'Novajidrány',
	'Nőtincs',
	'Nyalka',
	'Nyárád',
	'Nyáregyháza',
	'Nyárlőrinc',
	'Nyársapát',
	'Nyékládháza',
	'Nyergesújfalu',
	'Nyésta',
	'Nyim',
	'Nyírábrány',
	'Nyíracsád',
	'Nyirád',
	'Nyíradony',
	'Nyírbátor',
	'Nyírbéltek',
	'Nyírbogát',
	'Nyírbogdány',
	'Nyírcsaholy',
	'Nyírcsászári',
	'Nyírderzs',
	'Nyíregyháza',
	'Nyírgelse',
	'Nyírgyulaj',
	'Nyíri',
	'Nyíribrony',
	'Nyírjákó',
	'Nyírkarász',
	'Nyírkáta',
	'Nyírkércs',
	'Nyírlövő',
	'Nyírlugos',
	'Nyírmada',
	'Nyírmártonfalva',
	'Nyírmeggyes',
	'Nyírmihálydi',
	'Nyírparasznya',
	'Nyírpazony',
	'Nyírpilis',
	'Nyírtass',
	'NyÍrtelek',
	'Nyírtét',
	'Nyírtura',
	'Nyírvasvári',
	'Nyomár',
	'Nyőgér',
	'Nyugotszenterzsébet',
	'Nyúl',
	'Óbánya',
	'Óbarok',
	'Óbudavár',
	'Ócsa',
	'Ócsárd',
	'Ófalu',
	'Ófehértó',
	'Óföldeák',
	'Óhíd',
	'Okány',
	'Okorág',
	'Okorvölgy',
	'Olasz',
	'Olaszfa',
	'Olaszfalu',
	'Olaszliszka',
	'Olcsva',
	'Olcsvaapáti',
	'Old',
	'Ólmod',
	'Oltárc',
	'Onga',
	'Ónod',
	'Ópályi',
	'Ópusztaszer',
	'Orbányosfa',
	'Orci',
	'Ordacsehi',
	'Ordas',
	'Orfalu',
	'Orfű',
	'Orgovány',
	'Ormándlak',
	'Ormosbánya',
	'Orosháza',
	'Oroszi',
	'Oroszlány',
	'Oroszló',
	'Orosztony',
	'Ortaháza',
	'Osli',
	'Ostffyasszonyfa',
	'Ostoros',
	'Oszkó',
	'Oszlár',
	'Osztopán',
	'Ózd',
	'Ózdfalu',
	'Ozmánbük',
	'Ozora',
	'Öcs',
	'Őcsény',
	'Öcsöd',
	'Ököritófülpös',
	'Ölbő',
	'Ömböly',
	'Őr',
	'Őrbottyán',
	'Öregcsertő',
	'Öreglak',
	'Őrhalom',
	'Őrimagyarósd',
	'Őriszentpéter',
	'Örkény',
	'Örményes',
	'Örménykút',
	'Őrtilos',
	'Ősagárd',
	'Ősi',
	'Öskü',
	'Öttevény',
	'Öttömös',
	'Ötvöskónyi',
	'Pácin',
	'Pacsa',
	'Pácsony',
	'Padár',
	'Páhi',
	'Páka',
	'Pakod',
	'Pákozd',
	'Paks',
	'Palé',
	'Pálfa',
	'Pálfiszeg',
	'Pálháza',
	'Páli',
	'Palkonya',
	'Pálmajor',
	'Pálmonostora',
	'Pálosvörösmart',
	'Palotabozsok',
	'Palotás',
	'Paloznak',
	'Pamlény',
	'Pamuk',
	'Pánd',
	'Pankasz',
	'Pannonhalma',
	'Pányok',
	'Panyola',
	'Pap',
	'Pápa',
	'Pápadereske',
	'Pápakovácsi',
	'Pápasalamon',
	'Pápateszér',
	'Papkeszi',
	'Pápoc',
	'Papos',
	'Páprád',
	'Parád',
	'Parádsasvár',
	'Parasznya',
	'Pári',
	'Paszab',
	'Pásztó',
	'Pásztori',
	'Pat',
	'Patak',
	'Patalom',
	'Patapoklosi',
	'Patca',
	'Pátka',
	'Patosfa',
	'Pátroha',
	'Patvarc',
	'Páty',
	'Pátyod',
	'Pázmánd',
	'Pázmándfalu',
	'Pécel',
	'Pecöl',
	'Pécs',
	'Pécsbagota',
	'Pécsdevecser',
	'Pécsely',
	'Pécsudvard',
	'Pécsvárad',
	'Pellérd',
	'Pély',
	'Penc',
	'Penészlek',
	'Pénzesgyőr',
	'Penyige',
	'Pér',
	'Perbál',
	'Pere',
	'Perecse',
	'Pereked',
	'Perenye',
	'Peresznye',
	'Pereszteg',
	'Perkáta',
	'Perkupa',
	'Perőcsény',
	'Peterd',
	'Péterhida',
	'Péteri',
	'Pétervására',
	'Pétfürdő',
	'Pethőhenye',
	'Petneháza',
	'Petőfibánya',
	'Petőfiszállás',
	'Petőháza',
	'Petőmihályfa',
	'Petrikeresztúr',
	'Petrivente',
	'Pettend',
	'Piliny',
	'Pilis',
	'Pilisborosjenő',
	'Piliscsaba',
	'Piliscsév',
	'Pilisjászfalu',
	'Pilismarót',
	'Pilisvörösvár',
	'Pilisszántó',
	'Pilisszentiván',
	'Pilisszentkereszt',
	'Pilisszentlászló',
	'Pinkamindszent',
	'Pinnye',
	'Piricse',
	'Pirtó',
	'Piskó',
	'Pitvaros',
	'Pócsa',
	'Pocsaj',
	'Pócsmegyer',
	'Pócspetri',
	'Pogány',
	'Pogányszentpéter',
	'Pókaszepetk',
	'Polány',
	'Polgár',
	'Polgárdi',
	'Pomáz',
	'Porcsalma',
	'Pornóapáti',
	'Poroszló',
	'Porpác',
	'Porrog',
	'Porrogszentkirály',
	'Porrogszentpál',
	'Pórszombat',
	'Porva',
	'Pósfa',
	'Potony',
	'Potyond',
	'Pölöske',
	'Pölöskefő',
	'Pörböly',
	'Pördefölde',
	'Pötréte',
	'Prügy',
	'Pula',
	'Pusztaapáti',
	'Pusztaberki',
	'Pusztacsalád',
	'Pusztacsó',
	'Pusztadobos',
	'Pusztaederics',
	'Pusztafalu',
	'Pusztaföldvár',
	'Pusztahencse',
	'Pusztakovácsi',
	'Pusztamagyaród',
	'Pusztamérges',
	'Pusztamiske',
	'Pusztamonostor',
	'Pusztaottlaka',
	'Pusztaradvány',
	'Pusztaszabolcs',
	'Pusztaszemes',
	'Pusztaszentlászló',
	'Pusztaszer',
	'Pusztavacs',
	'Pusztavám',
	'Pusztazámor',
	'Putnok',
	'Püski',
	'Püspökhatvan',
	'Püspökladány',
	'Püspökmolnári',
	'Püspökszilágy',
	'Rábacsanak',
	'Rábacsécsény',
	'Rábagyarmat',
	'Rábahídvég',
	'Rábakecöl',
	'Rábapatona',
	'Rábapaty',
	'Rábapordány',
	'Rábasebes',
	'Rábaszentandrás',
	'Rábaszentmihály',
	'Rábaszentmiklós',
	'Rábatamási',
	'Rábatöttös',
	'Rábcakapi',
	'Rácalmás',
	'Ráckeresztúr',
	'Ráckeve',
	'Rád',
	'Rádfalva',
	'Rádóckölked',
	'Radostyán',
	'Ragály',
	'Rajka',
	'Rakaca',
	'Rakacaszend',
	'Rakamaz',
	'Rákóczibánya',
	'Rákóczifalva',
	'Rákócziújfalu',
	'Ráksi',
	'Ramocsa',
	'Ramocsaháza',
	'Rápolt',
	'Raposka',
	'Rásonysápberencs',
	'Rátka',
	'Rátót',
	'Ravazd',
	'Recsk',
	'Réde',
	'Rédics',
	'Regéc',
	'Regenye',
	'Regöly',
	'Rém',
	'Remeteszőlős',
	'Répáshuta',
	'Répcelak',
	'Répceszemere',
	'Répceszentgyörgy',
	'Répcevis',
	'Resznek',
	'Rétalap',
	'Rétközberencs',
	'Rétság',
	'Révfülöp',
	'Révleányvár',
	'Rezi',
	'Ricse',
	'Rigács',
	'Rigyác',
	'Rimóc',
	'Rinyabesenyő',
	'Rinyakovácsi',
	'Rinyaszentkirály',
	'Rinyaújlak',
	'Rinyaújnép',
	'Rohod',
	'Románd',
	'Romhány',
	'Romonya',
	'Rózsafa',
	'Rozsály',
	'Rózsaszentmárton',
	'Röjtökmuzsaj',
	'Rönök',
	'Röszke',
	'Rudabánya',
	'Rudolftelep',
	'Rum',
	'Ruzsa',
	'Ságújfalu',
	'Ságvár',
	'Sajóbábony',
	'Sajóecseg',
	'Sajógalgóc',
	'Sajóhídvég',
	'Sajóivánka',
	'Sajókápolna',
	'Sajókaza',
	'Sajókeresztúr',
	'Sajólád',
	'Sajólászlófalva',
	'Sajómercse',
	'Sajónémeti',
	'Sajóörös',
	'Sajópálfala',
	'Sajópetri',
	'Sajópüspöki',
	'Sajósenye',
	'Sajószentpéter',
	'Sajószöged',
	'Sajóvámos',
	'Sajóvelezd',
	'Sajtoskál',
	'Salföld',
	'Salgótarján',
	'Salköveskút',
	'Salomvár',
	'Sály',
	'Sámod',
	'Sámsonháza',
	'Sand',
	'Sándorfalva',
	'Sántos',
	'Sáp',
	'Sáránd',
	'Sárazsadány',
	'Sárbogárd',
	'Sáregres',
	'Sárfimizdó',
	'Sárhida',
	'Sárisáp',
	'Sarkad',
	'Sarkadkeresztúr',
	'Sárkeresztes',
	'Sárkeresztúr',
	'Sárkeszi',
	'Sármellék',
	'Sárok',
	'Sárosd',
	'Sárospatak',
	'Sárpilis',
	'Sárrétudvari',
	'Sarród',
	'Sárszentágota',
	'Sárszentlőrinc',
	'Sárszentmihály',
	'Sarud',
	'Sárvár',
	'Sásd',
	'Sáska',
	'Sáta',
	'Sátoraljaújhely',
	'Sátorhely',
	'Sávoly',
	'Sé',
	'Segesd',
	'Selyeb',
	'Sellye',
	'Semjén',
	'Semjénháza',
	'Sénye',
	'Sényő',
	'Seregélyes',
	'Serényfalva',
	'Sérsekszőlős',
	'Sikátor',
	'Siklós',
	'Siklósbodony',
	'Siklósnagyfalu',
	'Sima',
	'Simaság',
	'Simonfa',
	'Simontornya',
	'Sióagárd',
	'Siófok',
	'Siójut',
	'Sirok',
	'Sitke',
	'Sobor',
	'Sokorópátka',
	'Solt',
	'Soltszentimre',
	'Soltvadkert',
	'Sóly',
	'Solymár',
	'Som',
	'Somberek',
	'Somlójenő',
	'Somlószőlős',
	'Somlóvásárhely',
	'Somlóvecse',
	'Somodor',
	'Somogyacsa',
	'Somogyapáti',
	'Somogyaracs',
	'Somogyaszaló',
	'Somogybabod',
	'Somogybükkösd',
	'Somogycsicsó',
	'Somogydöröcske',
	'Somogyegres',
	'Somogyfajsz',
	'Somogygeszti',
	'Somogyhárságy',
	'Somogyhatvan',
	'Somogyjád',
	'Somogymeggyes',
	'Somogysámson',
	'Somogysárd',
	'Somogysimonyi',
	'Somogyszentpál',
	'Somogyszil',
	'Somogyszob',
	'Somogytúr',
	'Somogyudvarhely',
	'Somogyvámos',
	'Somogyvár',
	'Somogyviszló',
	'Somogyzsitfa',
	'Somoskőújfalu',
	'Sonkád',
	'Soponya',
	'Sopron',
	'Sopronhorpács',
	'Sopronkövesd',
	'Sopronnémeti',
	'Sorkifalud',
	'Sorkikápolna',
	'Sormás',
	'Sorokpolány',
	'Sóshartyán',
	'Sóskút',
	'Sóstófalva',
	'Sósvertike',
	'Sótony',
	'Söjtör',
	'Söpte',
	'Söréd',
	'Sukoró',
	'Sumony',
	'Súr',
	'Surd',
	'Sükösd',
	'Sülysáp',
	'Sümeg',
	'Sümegcsehi',
	'Sümegprága',
	'Süttő',
	'Szabadbattyán',
	'Szabadegyháza',
	'Szabadhídvég',
	'Szabadi',
	'Szabadkígyós',
	'Szabadszállás',
	'Szabadszentkirály',
	'Szabás',
	'Szabasdkígyós',
	'Szabolcs',
	'Szabolcsbáka',
	'Szabolcsveresmart',
	'Szada',
	'Szágy',
	'Szajk',
	'Szajla',
	'Szajol',
	'Szakácsi',
	'Szakadát',
	'Szakáld',
	'Szakály',
	'Szakcs',
	'Szakmár',
	'Szaknyér',
	'Szakoly',
	'Szakony',
	'Szakonyfalu',
	'Szákszend',
	'Szalafő',
	'Szalánta',
	'Szalapa',
	'Szalaszend',
	'Szalatnak',
	'Szálka',
	'Szalkszentmárton',
	'Szalmatercs',
	'Szalonna',
	'Szamosangyalos',
	'Szamosbecs',
	'Szamoskér',
	'Szamossályi',
	'Szamostatárfalva',
	'Szamosújlak',
	'Szamosszeg',
	'Szanda',
	'Szank',
	'Szántód',
	'Szany',
	'Szápár',
	'Szaporca',
	'Szár',
	'Szárász',
	'Szárazd',
	'Szárföld',
	'Szárliget',
	'Szarvas',
	'Szarvasgede',
	'Szarvaskend',
	'Szarvaskő',
	'Szászberek',
	'Szászfa',
	'Szászvár',
	'Szatmárcseke',
	'Szátok',
	'Szatta',
	'Szatymaz',
	'Szava',
	'Százhalombatta',
	'Szebény',
	'Szécsénke',
	'Szécsény',
	'Szécsényfelfalu',
	'Szécsisziget',
	'Szederkény',
	'Szedres',
	'Szeged',
	'Szegerdő',
	'Szeghalom',
	'Szegi',
	'Szegilong',
	'Szegvár',
	'Székely',
	'Székelyszabar',
	'Székesfehérvár',
	'Székkutas',
	'Szekszárd',
	'Szeleste',
	'Szelevény',
	'Szellő',
	'Szemely',
	'Szemenye',
	'Szemere',
	'Szendehely',
	'Szendrő',
	'Szendrőlád',
	'Szenna',
	'Szenta',
	'Szentantalfa',
	'Szentbalázs',
	'Szentbékkálla',
	'Szentborbás',
	'Szentdénes',
	'Szentdomonkos',
	'Szente',
	'Szentegát',
	'Szentendre',
	'Szentes',
	'Szentgál',
	'Szentgáloskér',
	'Szentgotthárd',
	'Szentgyörgyvár',
	'Szentgyörgyvölgy',
	'Szentimrefalva',
	'Szentistván',
	'Szentistvánbaksa',
	'Szentjakabfa',
	'Szentkatalin',
	'Szentkirály',
	'Szentkirályszabadja',
	'Szentkozmadombja',
	'Szentlászló',
	'Szentliszló',
	'Szentlőrinc',
	'Szentlőrinckáta',
	'Szentmargitfalva',
	'Szentmártonkáta',
	'Szentpéterfa',
	'Szentpéterfölde',
	'Szentpéterszeg',
	'Szentpéterúr',
	'Szenyér',
	'Szepetnek',
	'Szerecseny',
	'Szeremle',
	'Szerencs',
	'Szerep',
	'Szergény',
	'Szigetbecse',
	'Szigetcsép',
	'Szigethalom',
	'Szigetmonostor',
	'Szigetszentmárton',
	'Szigetszentmiklós',
	'Szigetújfalu',
	'Szigetvár',
	'Szigliget',
	'Szihalom',
	'Szíjártóháza',
	'Szikszó',
	'Szil',
	'Szilágy',
	'Szilaspogony',
	'Szilsárkány',
	'Szilvágy',
	'Szilvás',
	'Szilvásvárad',
	'Szilvásszentmárton',
	'Szin',
	'Szinpetri',
	'Szirák',
	'Szirmabesenyő',
	'Szob',
	'Szokolya',
	'Szólád',
	'Szolnok',
	'Szombathely',
	'Szomód',
	'Szomolya',
	'Szomor',
	'Szorgalmatos',
	'Szorosad',
	'Szőc',
	'Szőce',
	'Sződ',
	'Sződliget',
	'Szögliget',
	'Szőke',
	'Szőkéd',
	'Szőkedencs',
	'Szőlősardó',
	'Szőlősgyörök',
	'Szörény',
	'Szúcs',
	'Szuha',
	'Szuhafő',
	'Szuhakálló',
	'Szuhogy',
	'Szulimán',
	'Szulok',
	'Szurdokpüspöki',
	'Szűcsi',
	'Szügy',
	'Szűr',
	'Tab',
	'Tabajd',
	'Tabdi',
	'Táborfalva',
	'Tác',
	'Tagyon',
	'Tahitótfalu',
	'Takácsi',
	'Tákos',
	'Taksony',
	'Taktabáj',
	'Taktaharkány',
	'Taktakenéz',
	'Taktaszada',
	'Taliándörögd',
	'Tállya',
	'Tamási',
	'Tanakajd',
	'Táp',
	'Tápióbicske',
	'Tápiógyörgye',
	'Tápióság',
	'Tápiószecső',
	'Tápiószele',
	'Tápiószentmárton',
	'Tápiószőlős',
	'Táplánszentkereszt',
	'Tapolca',
	'Tapsony',
	'Tápszentmiklós',
	'Tar',
	'Tarany',
	'Tarcal',
	'Tard',
	'Tardona',
	'Tardos',
	'Tarhos',
	'Tarján',
	'Tarjánpuszta',
	'Tarnabod',
	'Tarnalelesz',
	'Tarnaméra',
	'Tarnaörs',
	'Tarnaszentmária',
	'Tarnaszentmiklós',
	'Tarnazsadány',
	'Tárnok',
	'Tárnokréti',
	'Tarpa',
	'Tarrós',
	'Táska',
	'Tass',
	'Taszár',
	'Tát',
	'Tata',
	'Tatabánya',
	'Tataháza',
	'Tatárszentgyörgy',
	'Tázlár',
	'Téglás',
	'Tekenye',
	'Tékes',
	'Teklafalu',
	'Telekes',
	'Telekgerendás',
	'Teleki',
	'Telki',
	'Telkibánya',
	'Tengelic',
	'Tengeri',
	'Tengőd',
	'Tenk',
	'Tényő',
	'Tépe',
	'Terem',
	'Terény',
	'Tereske',
	'Teresztenye',
	'Terpes',
	'Tés',
	'Tésa',
	'Tésenfa',
	'Téseny',
	'Teskánd',
	'Tét',
	'Tetétlen',
	'Tevel',
	'Tibolddaróc',
	'Tiborszállás',
	'Tihany',
	'Tikos',
	'Tilaj',
	'Timár',
	'Tinnye',
	'Tiszaadony',
	'Tiszaalpár',
	'Tiszabábolna',
	'Tiszabecs',
	'Tiszabercel',
	'Tiszabezdéd',
	'Tiszabő',
	'Tiszabura',
	'Tiszacsécse',
	'Tiszacsege',
	'Tiszacsermely',
	'Tiszadada',
	'Tiszaderzs',
	'Tiszadob',
	'Tiszadorogma',
	'Tiszaeszlár',
	'Tiszaföldvár',
	'Tiszafüred',
	'Tiszagyenda',
	'Tiszagyulaháza',
	'Tiszaigar',
	'Tiszainoka',
	'Tiszajenő',
	'Tiszakanyár',
	'Tiszakarád',
	'Tiszakécske',
	'Tiszakerecseny',
	'Tiszakeszi',
	'Tiszakóród',
	'Tiszakürt',
	'Tiszaladány',
	'Tiszalök',
	'Tiszalúc',
	'Tiszamogyorós',
	'Tiszanagyfalu',
	'Tiszanána',
	'Tiszaörs',
	'Tiszapalkonya',
	'Tiszapüspöki',
	'Tiszarád',
	'Tiszaroff',
	'Tiszasas',
	'Tiszasüly',
	'Tiszaszalka',
	'Tiszaszentimre',
	'Tiszaszentmárton',
	'Tiszasziget',
	'Tiszaszőlős',
	'Tiszatardos',
	'Tiszatarján',
	'Tiszatelek',
	'Tiszatenyő',
	'Tiszaug',
	'Tiszaújváros',
	'Tiszavalk',
	'Tiszavárkony',
	'Tiszavasvári',
	'Tiszavid',
	'Tisztaberek',
	'Tivadar',
	'Tóalmás',
	'Tófalu',
	'Tófej',
	'Tófű',
	'Tokaj',
	'Tokod',
	'Tokodaltáró',
	'Tokorcs',
	'Tolcsva',
	'Told',
	'Tolmács',
	'Tolna',
	'Tolnanémedi',
	'Tomajmonostora',
	'Tomor',
	'Tompa',
	'Tompaládony',
	'Tordas',
	'Tormafölde',
	'Tormás',
	'Tormásliget',
	'Tornabarakony',
	'Tornakápolna',
	'Tornanádaska',
	'Tornaszentandrás',
	'Tornaszentjakab',
	'Tornyiszentmiklós',
	'Tornyosnémeti',
	'Tornyospálca',
	'Torony',
	'Torvaj',
	'Tószeg',
	'Tótkomlós',
	'Tótszentgyörgy',
	'Tótszentmárton',
	'Tótszerdahely',
	'Tótújfalu',
	'Tótvázsony',
	'Tök',
	'Tököl',
	'Töltéstava',
	'Tömörd',
	'Tömörkény',
	'Törökbálint',
	'Törökkoppány',
	'Törökszentmiklós',
	'Törtel',
	'Töttös',
	'Trizs',
	'Tunyogmatolcs',
	'Tura',
	'Túristvándi',
	'Túrkeve',
	'Túrony',
	'Túrricse',
	'Tuzsér',
	'Türje',
	'Tüskevár',
	'Tyukod',
	'Udvar',
	'Udvari',
	'Ugod',
	'Újbarok',
	'Újcsanálos',
	'Újdombrád',
	'Újfehértó',
	'Újhartyán',
	'Újiráz',
	'Újireg',
	'Újkenéz',
	'Újkér',
	'Újkígyós',
	'Újlengyel',
	'Újléta',
	'Újlőrincfalva',
	'Újpetre',
	'Újrónafő',
	'Újsolt',
	'Újszalonta',
	'Újszász',
	'Újszentiván',
	'Újszentmargita',
	'Újszilvás',
	'Újtelek',
	'Újtikos',
	'Újudvar',
	'Újvárfalva',
	'Ukk',
	'Und',
	'Úny',
	'Uppony',
	'Ura',
	'Uraiújfalu',
	'Úrhida',
	'Úri',
	'Úrkút',
	'Uszka',
	'Uszód',
	'Uzsa',
	'Üllés',
	'Üllő',
	'Üröm',
	'Vác',
	'Vácduka',
	'Vácegres',
	'Váchartyán',
	'Váckisújfalu',
	'Vácrátót',
	'Vácszentlászló',
	'Vadna',
	'Vadosfa',
	'Vág',
	'Vágáshuta',
	'Vaja',
	'Vajdácska',
	'Vajszló',
	'Vajta',
	'Vál',
	'Valkó',
	'Valkonya',
	'Vállaj',
	'Vállus',
	'Vámosatya',
	'Vámoscsalád',
	'Vámosgyörk',
	'Vámosmikola',
	'Vámosoroszi',
	'Vámospércs',
	'Vámosújfalu',
	'Vámosszabadi',
	'Váncsod',
	'Vanyarc',
	'Vanyola',
	'Várad',
	'Váralja',
	'Varászló',
	'Váraszó',
	'Várbalog',
	'Varbó',
	'Varbóc',
	'Várda',
	'Várdomb',
	'Várfölde',
	'Varga',
	'Várgesztes',
	'Várkesző',
	'Várong',
	'Városföld',
	'Városlőd',
	'Várpalota',
	'Varsád',
	'Varsány',
	'Várvölgy',
	'Vasad',
	'Vasalja',
	'Vásárosbéc',
	'Vásárosdombó',
	'Vásárosfalu',
	'Vásárosmiske',
	'Vásárosnamény',
	'Vasasszonyfa',
	'Vasboldogasszony',
	'Vasegerszeg',
	'Vashosszúfalu',
	'Vaskeresztes',
	'Vaskút',
	'Vasmegyer',
	'Vaspör',
	'Vassurány',
	'Vasvár',
	'Vaszar',
	'Vászoly',
	'Vasszécseny',
	'Vasszentmihály',
	'Vasszilvágy',
	'Vát',
	'Vatta',
	'Vázsnok',
	'Vécs',
	'Vecsés',
	'Végegyháza',
	'Vejti',
	'Vékény',
	'Vekerd',
	'Velem',
	'Velemér',
	'Velence',
	'Velény',
	'Véménd',
	'Vének',
	'Vép',
	'Vereb',
	'Veresegyház',
	'Verőce',
	'Verpelét',
	'Verseg',
	'Versend',
	'Vértesacsa',
	'Vértesboglár',
	'Vérteskethely',
	'Vértessomló',
	'Vértestolna',
	'Vértesszőlős',
	'Vése',
	'Veszkény',
	'Veszprém',
	'Veszprémfajsz',
	'Veszprémgalsa',
	'Veszprémvarsány',
	'Vésztő',
	'Vezseny',
	'Vid',
	'Vigántpetend',
	'Villány',
	'Villánykövesd',
	'Vilmány',
	'Vilonya',
	'Vilyvitány',
	'Vinár',
	'Vindornyafok',
	'Vindornyalak',
	'Vindornyaszőlős',
	'Visegrád',
	'Visnye',
	'Visonta',
	'Viss',
	'Visz',
	'Viszák',
	'Viszló',
	'Visznek',
	'Vitnyéd',
	'Vízvár',
	'Vizslás',
	'Vizsoly',
	'Vokány',
	'Vonyarcvashegy',
	'Vöckönd',
	'Völcsej',
	'Vönöck',
	'Vöröstó',
	'Vörs',
	'Zabar',
	'Zádor',
	'Zádorfalva',
	'Zagyvarékas',
	'Zagyvaszántó',
	'Záhony',
	'Zajk',
	'Zajta',
	'Zákány',
	'Zákányfalu',
	'Zákányszék',
	'Zala',
	'Zalaapáti',
	'Zalabaksa',
	'Zalabér',
	'Zalaboldogfa',
	'Zalacsány',
	'Zalacséb',
	'Zalaegerszeg',
	'Zalaerdőd',
	'Zalagyömörő',
	'Zalahaláp',
	'Zalaháshágy',
	'Zalaigrice',
	'Zalaistvánd',
	'Zalakaros',
	'Zalakomár',
	'Zalaköveskút',
	'Zalalövő',
	'Zalameggyes',
	'Zalamerenye',
	'Zalasárszeg',
	'Zalaszabar',
	'Zalaszántó',
	'Zalaszegvár',
	'Zalaszentbalázs',
	'Zalaszentgrót',
	'Zalaszentgyörgy',
	'Zalaszentiván',
	'Zalaszentjakab',
	'Zalaszentlászló',
	'Zalaszentlőrinc',
	'Zalaszentmárton',
	'Zalaszentmihály',
	'Zalaszombatfa',
	'Zaláta',
	'Zalatárnok',
	'Zalaújlak',
	'Zalavár',
	'Zalavég',
	'Zalkod',
	'Zamárdi',
	'Zámoly',
	'Zánka',
	'Zaránk',
	'Závod',
	'Zebecke',
	'Zebegény',
	'Zemplénagárd',
	'Zengővárkony',
	'Zichyújfalu',
	'Zics',
	'Ziliz',
	'Zimány',
	'Zirc',
	'Zók',
	'Zomba',
	'Zubogy',
	'Zsadány',
	'Zsáka',
	'Zsámbék',
	'Zsámbok',
	'Zsana',
	'Zsarolyán',
	'Zsebeháza',
	'Zsédeny',
	'Zselickisfalud',
	'Zselickislak',
	'Zselicszentpál',
	'Zsennye',
	'Zsira',
	'Zsombó',
	'Zsujta',
	'Zsurk'
];
